import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizAllBanner from "../../../../styles/img/quiz-all-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBaner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr, UiContentPinkCol } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import { QuizzerCard } from "./Views/QuizzerCard";
import volvoLogo from '../../../../styles/img/volvo-logo-round.png';
import Footer from "../../components/footer/Footer";
import { UiNavTabs, UiNavTab } from "../../components/common/UiNavTabs"
import BadgesBox from "../../components/common/BadgesBox"
import { KnowledgeHowToEarn } from "./Views/KnowledgeHowToEarn";
import GetBadges from "./Views/GetBadges"
import { UiButtonPrimary } from "../../components/form/UiButton"
import { UiCardTitle } from "../../components/common/UiCardTitle";
import { WifiIcon } from "../../../../styles/img/svg/WifiIcon";
import { SizeIcon } from "../../../../styles/img/svg/SizeIcon"
import {
    UiCourseFeatureWr,
    UiCourseFeatureIcon,
    UiCourseFeatureText,
    UiCourseFeaturePointBox,
    UiCourseContentFeatures
} from "../../components/common/UiCourseFeatures"
import GalleryImg from "../../../../styles/img/banded-banner.jpg"
import {WhatIsNeededToParticipate} from "./Views/WhatIsNeededToParticipate"
import ViewBadgesInner from "../../../../styles/img/view-badges-inner.png"

export const ViewBadgesDetails = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Volvo Basics"
                    description="Here you will learn the basics of the new Volvo range included the new 4x4 and it's interiors and earn up to "
                    sliderCardImage={ViewBadgesInner}
                    courses={true}
                    points="20"
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="  Learning History"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiContentPinkCol>
                        <UiRowContainer>
                            <UiCol lg="8" >
                                <div className="sb-badge-still-to-earn ps-md-5 ps-3">
                                    <UiSingleRow>
                                        <UiCol lg="8" className="mb-3 mb-md-0">
                                            <h5>Badge Still to Earn</h5>
                                            <p>Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum</p>
                                            <UiButtonPrimary btnName="Start" />
                                        </UiCol>
                                        <UiCol lg="4">
                                            <BadgesBox />
                                        </UiCol>
                                    </UiSingleRow>
                                </div>
                            </UiCol>
                            <UiCol lg="4" className="my-auto text-center pt-3 pt-md-0">
                                <img src={volvoLogo} />
                            </UiCol>
                        </UiRowContainer>
                    </UiContentPinkCol>

                </UiContentWr>
                <UiContentWr>
                    <UiContentCol>
                        <UiSingleRow>
                            <UiCol lg="12">
                                <UiCardTitle title="Course Information" />
                            </UiCol>
                            <UiCol lg="3" className="sb-course-information">
                                <h5>Course Features</h5>
                                <UiSingleRow>
                                    <UiCol lg="6">
                                        <UiCourseFeatureWr>
                                            <UiCourseFeatureIcon>
                                                <WifiIcon />
                                            </UiCourseFeatureIcon>
                                            <UiCourseFeatureText text="Text" />
                                        </UiCourseFeatureWr>
                                    </UiCol>
                                    <UiCol lg="6">
                                        <UiCourseFeatureWr>
                                            <UiCourseFeatureIcon>
                                                <SizeIcon />
                                            </UiCourseFeatureIcon>
                                            <UiCourseFeatureText text="Text" />
                                        </UiCourseFeatureWr>
                                    </UiCol>
                                    <UiCol lg="6">
                                        <UiCourseFeatureWr>
                                            <UiCourseFeatureIcon>
                                                <WifiIcon />
                                            </UiCourseFeatureIcon>
                                            <UiCourseFeatureText text="Text" />
                                        </UiCourseFeatureWr>
                                    </UiCol>
                                    <UiCol lg="6">
                                        <UiCourseFeatureWr>
                                            <UiCourseFeatureIcon>
                                                <SizeIcon />
                                            </UiCourseFeatureIcon>
                                            <UiCourseFeatureText text="Text" />
                                        </UiCourseFeatureWr>
                                    </UiCol>
                                </UiSingleRow>


                            </UiCol>
                            <UiCol lg="9">
                                <UiSingleRow>
                                    <UiCol lg="3" className="mb-2 mb-md-0">
                                        <UiCourseFeaturePointBox />
                                    </UiCol>
                                    <UiCol lg="3" className="mb-2 mb-md-0">
                                        <UiCourseFeaturePointBox />
                                    </UiCol>
                                    <UiCol lg="3" className="mb-2 mb-md-0">
                                        <UiCourseFeaturePointBox />
                                    </UiCol>
                                    <UiCol lg="3" className="mb-2 mb-md-0">
                                        <UiCourseFeaturePointBox />
                                    </UiCol>
                                </UiSingleRow>
                            </UiCol>
                            <UiCol lg="12" className="sb-course-features-paragraph">
                                <h4>Lorem Epsum</h4>
                                <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
                                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam.</p>
                            </UiCol>
                        </UiSingleRow>
                    </UiContentCol>
                </UiContentWr>
                <UiContentWr>
                    <UiContentCol>
                        <UiSingleRow>
                            <UiCol lg="12" className="sb-course-features-overview-title">
                                <UiCardTitle title="Overview" />
                                <h4>Course Features</h4>
                            </UiCol>
                            <UiCourseContentFeatures wifi={true}
                                bathup={true}
                                breakfast={true}
                                kingbed={true}
                                size={true} />
                        </UiSingleRow>
                    </UiContentCol>
                </UiContentWr>
                <UiContentWr>
                    <div className="sb-course-features-galley">
                        <div className="sb-course-features-galley__item-top-sm">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-top-md">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-top-sm">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-top-md">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-top-sm gallery-top-last-child">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-bottom-sm">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-bottom-md">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-bottom-sm">
                            <img src={GalleryImg}/>
                        </div>
                        <div className="sb-course-features-galley__item-bottom-md gallery-top-last-child">
                            <img src={GalleryImg}/>
                        </div>
                    </div>
                </UiContentWr>
                <WhatIsNeededToParticipate />
                <Footer />

            </UiMainWrapper>


        </>
    )
}
